module.exports = __webpack_public_path__ + "static/media/6_4.d885ed49.png";